<script>
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import AutocompleteInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/AutocompleteInput.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import { showToast, ToastError } from "@sourcewhale/core";
  import CrmFeatureGuard from "../../../../../components/feature-flags/CrmFeatureGuard.svelte";
  import { editContactStore } from "../../../stores";
  import { fetchCompanySuggestions, handleCompanySelect } from "../stores";

  let suggestions = [];
  let showSuggestions = false;
  let fetchTimeout;
  let lastValue = "";
  let isTyping = false;
  let isLoading = false;

  const onInputEvent = (_event) => {
    isTyping = true;
  };

  const onSelectSuggestion = (suggestion) => {
    handleCompanySelect(suggestion);
    isTyping = false;
    showSuggestions = false;
  };

  const handleBlur = () => {
    setTimeout(() => {
      showSuggestions = false;
      isTyping = false;
    }, 200);
  };

  const fetchSuggestions = async (name) => {
    try {
      const results = await fetchCompanySuggestions(name.trim());
      return results;
    } catch (error) {
      if (error instanceof ToastError) {
        showToast(error);
        return [];
      }
      throw error;
    }
  };

  const debouncedFetch = async (name) => {
    if (name === lastValue || !isTyping) return;

    clearTimeout(fetchTimeout);
    fetchTimeout = setTimeout(async () => {
      lastValue = name;
      isLoading = true;
      suggestions = await fetchSuggestions(name);
      isLoading = false;
      showSuggestions = suggestions.length > 0 && isTyping;
    }, 300);
  };

  $: if ($editContactStore.company && isTyping) {
    debouncedFetch($editContactStore.company);
  } else if (!$editContactStore.company) {
    suggestions = [];
    showSuggestions = false;
  }
</script>

<CrmFeatureGuard>
  {#snippet crmContent()}
    <AutocompleteInput
      bind:value={$editContactStore.company}
      bind:show={showSuggestions}
      bind:isTyping
      bind:isLoading
      {suggestions}
      handleSelect={onSelectSuggestion}
      {handleBlur}
      on:input={onInputEvent}
      minChars={2}
      placeholder="Enter company name"
      label="Company"
      {...$$restProps}
    >
      <ListItem
        slot="item"
        let:suggestion
        let:selected
        let:select
        src={suggestion.data?.logo || ""}
        alt={suggestion.label}
        {selected}
        onclick={() => select(suggestion)}
      >
        {suggestion.label}
      </ListItem>
    </AutocompleteInput>
  {/snippet}
  {#snippet fallback()}
    <TextInput
      bind:value={$editContactStore.company}
      placeholder="Enter company name"
      label="Company"
      {...$$restProps}
    />
  {/snippet}
</CrmFeatureGuard>
